import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private data : BehaviorSubject<any> = new BehaviorSubject([]);
  public data$ : Observable<any> = this.data.asObservable();

  constructor() { }

  setDatavalue(value: any) {
    this.data.next(value);
  }

  getDataValue() : Observable<any> {
    return this.data;
  }
}
